import { cn } from '@/lib/utils'

type Tone = 'brand' | 'ok' | 'warning' | 'critical'

const toneClass: Record<Tone, string> = {
  brand: 'bg-brand-gradient',
  ok: 'bg-primary',
  warning: 'bg-warning',
  critical: 'bg-danger',
}

/** Accessible meter (role="meter"). `value` is 0..1; `null` renders an "unlimited" track. */
export function Meter({
  value,
  tone = 'ok',
  label,
  className,
  size = 'default',
}: {
  value: number | null
  tone?: Tone
  label?: string
  className?: string
  size?: 'sm' | 'default'
}) {
  const pct = value === null ? 0 : Math.round(Math.min(1, Math.max(0, value)) * 100)
  return (
    <div
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value === null ? undefined : pct}
      aria-valuetext={value === null ? 'Unlimited' : `${pct}%`}
      className={cn('relative w-full overflow-hidden rounded-full bg-muted', size === 'sm' ? 'h-1.5' : 'h-2', className)}
    >
      {value === null ? (
        <div className="absolute inset-0 bg-[repeating-linear-gradient(135deg,transparent_0_6px,color-mix(in_oklch,var(--primary)_14%,transparent)_6px_12px)]" />
      ) : (
        <div
          className={cn('h-full rounded-full transition-[width] duration-500 ease-out', toneClass[tone])}
          style={{ width: `${Math.max(pct, value > 0 ? 2 : 0)}%` }}
        />
      )}
    </div>
  )
}
